var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"link-large-underline link-default py-2 px-3 cursor-pointer",on:{"click":function($event){$event.stopPropagation();return _setup.handleClick.apply(null, arguments)}}},[_vm._t("default",function(){return [_vm._v(_vm._s(_setup.props.text))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }